// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/RightCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var RightCircleTwoTone = function RightCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleTwoToneSvg
  }));
};

RightCircleTwoTone.displayName = 'RightCircleTwoTone';
export default React.forwardRef(RightCircleTwoTone);